import { AdminUserApi, adminUsersApi } from "api/admin-users/adminUsersApi";
import { ROLES_IDS } from "consts/roles";
import { useEffect, useState } from "react";

export const useAdminUsers = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<AdminUserApi[]>([]);

  useEffect(() => {
    const fetchResources = async () => {
      const res = await adminUsersApi.fetch(0, 1_000_000, "", `roles in ('${ROLES_IDS.ADMIN}')`);
      try {
        setData(res.data.data);
      } catch (error) {
        // Handle error appropriately, perhaps with another state variable
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchResources();
  }, []);

  return { loading, data };
};

export const useAdminUsersOptions = () => {
  const { loading, data } = useAdminUsers();

  const options = data?.map((x) => ({
    value: x.id,
    label: `${x.firstName} ${x.surname}`,
  }));

  return { loading, options };
};
